// extracted by mini-css-extract-plugin
export default {"BlockContainer":"zJLrN","lightMargin":"WsXY1"};